export default __webpack_public_path__ + "static/media/112.28ef54fc.jpg";